import { render, staticRenderFns } from "./VoiceSelection.vue?vue&type=template&id=4bb5f816"
import script from "./VoiceSelection.vue?vue&type=script&lang=js"
export * from "./VoiceSelection.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports